import { employeeReviewStatusLabels, type EmployeeReviewStatus } from '../employeeReviewStatus';

type EmployeeReviewStatusCellProps = {
  value: unknown;
};

export const EmployeeReviewStatusCell = ({ value }: EmployeeReviewStatusCellProps) => {
  const status = Number(value) as EmployeeReviewStatus;
  return <>{employeeReviewStatusLabels[status] ?? String(value ?? '')}</>;
};
